import React, { useRef } from "react";
import PropTypes from "prop-types";
import { Modal, MODAL_ID } from "../../../shared-components"
import { Button, ButtonVariant, Icon, IconNames,  } from "@wattpad/web-ui-library";
import { useTrans } from "../../../hooks";


const RemovePollModal = ({title, subTitle, removeLabel, onRemove, onClose}) => {
    const modalRef = useRef();
    const { trans } = useTrans();

    return (
        <Modal
            id={MODAL_ID.REMOVE_POLL_MODAL}
            showModal={true}
            ref={modalRef}
            onClose={onClose}
        >
            <Icon name={IconNames.WpWarning} size={40}/>
            <div className={"remove-modal-title"}>{title}</div>
            <div className={"remove-modal-subtitle"}>{subTitle}</div>
            <Button 
                variant={ButtonVariant.PRIMARY}
                leadingIcon={IconNames.WpDelete}
                ariaLabel={trans("Delete")}
                label={removeLabel}
                onClick={onRemove}
                fullWidth
            />
            <Button 
                variant={ButtonVariant.SECONDARY}
                label={trans("Cancel")}
                onClick={() => onClose()}
                fullWidth
            />
        </Modal>
    )
}

RemovePollModal.propTypes = {
    title: PropTypes.string,
    subTitle: PropTypes.string,
    removeLabel: PropTypes.string,
    onRemove: PropTypes.func,
    onClose: PropTypes.func
};

export default RemovePollModal;